<template>
  <Modal
    :modal-active="modelValue"
    has-header-border
    has-footer-border
    max-width="max-w-[520px]"
    @close="emit('update:modelValue', false)"
  >
    <template #header>
      <h2 class="text-xl font-bold text-textPrimary text-left">
        Aprovar com linhas sem correspondência
      </h2>
    </template>

    <div class="flex flex-col gap-3 text-left">
      <p class="text-sm text-textPrimary">{{ message }}</p>
      <p class="text-sm text-neutral50">
        Ao aprovar, essas linhas ficam registradas na folha como divergentes e não geram check no
        plantão. Cancele para revisar a conciliação.
      </p>
    </div>

    <template #footer>
      <div class="flex flex-col sm:flex-row sm:justify-end gap-3">
        <OutlineButton
          text="Cancelar"
          width="96px"
          height="40px"
          data-testid="unmatched-approval-cancel-button"
          @click="emit('update:modelValue', false)"
        />
        <FilledButton
          text="Aprovar mesmo assim"
          class="bg-primary30"
          width="200px"
          height="40px"
          :disabled="saving"
          data-testid="unmatched-approval-confirm-button"
          @click="emit('confirm')"
        />
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import Modal from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import { unmatchedRowsMessage } from '../composables/useUnmatchedApprovalGate'

/**
 * Confirmação de "Aprovada" com linha sem correspondência (web#2336). Pela regra
 * da tela (minhaescala-product#42), a confirmação dá ciência de um efeito que a
 * tabela não mostra: as linhas aprovadas assim não geram check no plantão.
 */
const props = defineProps<{
  modelValue: boolean
  saving: boolean
  unmatchedCount: number
}>()

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
  confirm: []
}>()

const message = computed(() => unmatchedRowsMessage(props.unmatchedCount))
</script>
